import { createPersistedStore } from "./createPersistedStore";

// US 922643: the user's 12/24-hour clock preference, mirroring EAM web
// (sy_user_setup options/time_format, falling back to the TimeFormat EAM
// option, then 12h). Persisted so offline launches keep the last known value.
// Read it through util/DateHelper or hooks/useTimeFormat, never directly.
export type TimeFormat = "12h" | "24h";

type TimeFormatState = {
  timeFormat: TimeFormat;
};

type TimeFormatAction = {
  setTimeFormat: (timeFormat: TimeFormat) => void;
};

const defaultState: TimeFormatState = {
  timeFormat: "12h",
};

export const useTimeFormatStore = createPersistedStore<
  TimeFormatState,
  TimeFormatAction
>(
  defaultState,
  (set) => ({
    setTimeFormat(timeFormat) {
      set((state: any) => {
        state.timeFormat = timeFormat;
      });
    },
  }),
  "timeFormat",
  (state) => ({
    timeFormat: state.timeFormat,
  })
);
